import { ApolloQueryResult } from 'apollo-client';

import {
    getValueFromApiFormat,
    mapDateRangePresetToApiFormat,
    mapSortParamsToString,
    mapTotalStatsToApiFormat
} from '../../mappers/common/common';
import {
    mapFeedFilterFilterToApiFormat,
    mapRowsToFeedFilters
} from '../../mappers/feedFilters';
import { getDefaultSort } from '../../service/GridHelpers/GridHelpers';
import {
    FeedFiltersSuggestQuery,
    SmartFiltersGridQuery
} from '../../typings/graphql-grid';
import { defaultClientInfo, GridSourceParams } from '../../typings/grid';

export const mapFeedFilterQueryResultToEntitiesQueryResponse = (
    result: ApolloQueryResult<SmartFiltersGridQuery>,
    params: GridSourceParams
) => {
    const { client, reqId } = result.data;
    const { smartFilters: feedFilterResult } = client;
    const {
        rowset: feedFiltersRows,
        totalCount,
        cacheKey,
        smartFilterIds,
        totalStats
    } = feedFilterResult;

    const feedFilter = {
        data: {
            data: mapRowsToFeedFilters(feedFiltersRows, client, params),
            total: totalCount,
            allItemsIds: smartFilterIds,
            cacheKey: getValueFromApiFormat(cacheKey)
        },
        clientInfo: {
            ...defaultClientInfo
        },
        reqId,
        hasObjectsOverLimit: false
    };

    if (totalStats) {
        const { cost, shows, ctr, clicks } = totalStats;

        return {
            ...feedFilter,
            totalStats: mapTotalStatsToApiFormat({
                cost,
                clicks,
                shows,
                ctr
            })
        };
    }

    return feedFilter;
};

export const mapSourceParamsToFeedFiltersAndSuggestQueryVariables = (
    params: GridSourceParams
) => {
    const {
        campaignsIds,
        groupsIds,
        statPeriod,
        filter,
        sortParams,
        view
    } = params;

    let statRequirements;
    if (statPeriod) {
        const { statPreset, statFrom, statTo } = statPeriod;
        statRequirements = {
            preset: statPreset && mapDateRangePresetToApiFormat(statPreset),
            from: statFrom,
            to: statTo
        };
    }

    const apiFormatFilter = mapFeedFilterFilterToApiFormat(filter);

    return {
        orderBy: sortParams
            ? mapSortParamsToString(sortParams)
            : getDefaultSort(view),
        statRequirements,
        filter: {
            ...apiFormatFilter,
            campaignIdIn: campaignsIds,
            adGroupIdIn:
                groupsIds && groupsIds.length !== 0 ? groupsIds : undefined
        }
    };
};

export const mapFeedFilterSuggestQueryResultToSuggestQueryResponse = (
    result: ApolloQueryResult<FeedFiltersSuggestQuery>
) => {
    return {
        data: result.data.client.smartFilters.rowset.map(item => item.name),
        reqId: result.data.reqId
    };
};
